import React from 'react';
import Combobox from './primitives/Combobox';
import Departments, { Department } from '../../../views/Departments';
import { t } from '../l10n/l10n';

interface Props {
    hideInlineSearch: boolean;
    omitDistributionKeys: boolean;
    hideBarred: boolean;
    onCreated?: Function;
    [x: string]: any;
    hideSummary?: boolean;
    modalDraggable?: boolean;
}

export default function DepartmentCombobox({
    hideInlineSearch,
    omitDistributionKeys = false,
    hideBarred,
    onCreated,
    hideSummary = false,
    ...props
}: Props) {
    const includeDistributionKeys = !omitDistributionKeys;
    return (
        <Combobox
            {...props}
            aria-label={t`LEFTMENU_SETTINGS_DEPARTMENTS`}
            endpoint={`/departments?includeDistributionKeys=${includeDistributionKeys}&barred=${!hideBarred}`}
            transform={(departments: Department[]) =>
                departments.map(department => ({
                    data: department,
                    text: hideInlineSearch ? '' : `${department.number} - ${department.name}`,
                    summary: hideSummary ? undefined : department.name,
                    value: department.number,
                }))
            }
            modal={({ hide, onChange }) => (
                <Departments
                    modalDraggable={props.modalDraggable}
                    omitDistributionKeys={omitDistributionKeys}
                    showSaveAndApply
                    onCreated={department => {
                        onCreated?.();
                        onChange(department.number, department, true);
                        hide();
                    }}
                    onSelected={department => {
                        onChange(department.number, department);
                        hide();
                    }}
                    selectedDepartmentNumber={props.value}
                    hideBarred={hideBarred}
                />
            )}
            modalSize="sm"
            style={{ width: '120px' }}
        />
    );
}
